"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCacheConfig = void 0;
exports.defaultCacheConfig = {
    expiresTime: 60 * 5 * 1000,
    encrypted: false,
};
//# sourceMappingURL=index.js.map